export default __webpack_public_path__ + "static/media/16.1ea8e735.png";